namespace $ {
	/** Domain module tools independent of repository projects and the selected map. */
	export class $shm_hitalama_components_mcp extends $mol_object {
		name( params: Record< string, any > ) {
			if( typeof params.name !== 'string' || !/^\$[A-Za-z][A-Za-z0-9]*_[A-Za-z0-9_]+$/.test( params.name ) ) throw new Error( 'Укажите полный FQN модуля с namespace.' )
			return params.name as string
		}
		definition( params: Record< string, any > ) {
			const definition = this.$.$shm_hitalama_components_catalog.current()?.definition( this.name( params ) )
			if( !definition ) throw new Error( 'Модуль не найден.' )
			this.$.$shm_hitalama_map_component_ready.read( definition )
			return definition
		}
		kind( value: any ) {
			if( ![ 'tree', 'logic', 'style', 'demo', 'default', 'readme', 'dependencies' ].includes( value ) ) throw new Error( 'Неизвестный вид исходника.' )
			return value as $shm_hitalama_map_widget_entity_custom_source_kind | 'dependencies'
		}
		text( definition: $shm_hitalama_map_widget_entity_custom, kind: ReturnType< $shm_hitalama_components_mcp['kind'] > ) {
			if( kind === 'dependencies' ) return definition.Dependencies()?.val() ?? ''
			const source = definition.source_link( kind )
			if( source ) this.$.$shm_hitalama_map_component_ready.read( source )
			return definition.source_text( kind )
		}
		handle( method: string, params: Record< string, any > ) {
			if( [ 'application_open', 'application_ui', 'application_ui_action', 'application_screenshot' ].includes( method ) ) return $mol_wire_sync( this.ui() ).handle( method, params )
			if( [ 'application_tests', 'application_test_get', 'application_test_save', 'application_test_run', 'application_test_result', 'application_test_image' ].includes( method ) ) return $mol_wire_sync( this.scenarios() ).handle( method, params )
			if( method === 'application_modules' ) {
				const catalog = this.$.$shm_hitalama_components_catalog.current()
				if( catalog ) this.$.$shm_hitalama_map_component_ready.read( catalog )
				return { names: ( catalog?.Entries()?.keys() ?? [] ).map( String ).sort() }
			}
			if( method === 'application_module_create' ) {
				const definition = $mol_wire_sync( this.$.$shm_hitalama_components_catalog.ensure() ).create( params, this.name( params ) )
				return { name: definition.class_name(), link: definition.link().str }
			}
			const definition = this.definition( params )
			if( method === 'application_module_metadata' ) return params.patch === undefined ? this.metadata( definition ) : this.configure( definition, params )
			if( method === 'application_versions' ) return { entries: this.versions( params.name ).entries().map( entry => ({ id: entry.link().str, ...entry.info()! }) ) }
			if( method === 'application_version_publish' ) {
				const entry = $mol_wire_sync( this.versions( params.name ) ).publish( params, params.version, params.note, params as { repository: string, commit: string } )
				return { id: entry.link().str, ...entry.info()! }
			}
			if( method === 'application_module_get' ) {
				const kind = this.kind( params.kind )
				return { name: definition.class_name(), kind, text: this.text( definition, kind ) }
			}
			if( method === 'application_module_update' ) return this.update( definition, params )
			if( method === 'application_module_check' ) {
				const loader = this.loader(), graph = loader.graph( definition )
				for( const item of graph ) loader.compiler().compiled( loader.compiler().signature( item.source ) )
				return { name: definition.class_name(), compiled: true, modules: graph.map( item => item.source.fqn ), executes_user_code: false }
			}
			throw new Error( 'Неизвестная команда модулей приложения.' )
		}
		private ui_service?: $shm_hitalama_components_ui
		metadata( definition: $shm_hitalama_map_widget_entity_custom ) {
			return { name: definition.class_name(), link: definition.link().str, title: definition.title(), description: definition.Description()?.val() ?? '', widget_type: definition.widget_type() }
		}
		configure_plan( definition: $shm_hitalama_map_widget_entity_custom, params: Record<string, any> ) {
			if( !definition.can_change() ) throw new Error( 'Нет прав на изменение параметров модуля.' )
			const patch = params.patch
			if( !patch || typeof patch !== 'object' || Array.isArray( patch ) || !Object.keys( patch ).length ) throw new Error( 'Передайте непустой patch параметров.' )
			for( const key of Object.keys( patch ) ) {
				if( ![ 'title', 'description', 'widget_type' ].includes( key ) || typeof patch[key] !== ( key === 'widget_type' ? 'boolean' : 'string' ) ) throw new Error( 'Неизвестный параметр или неверный тип: ' + key )
			}
			const current = this.metadata( definition ), expected = params.expected
			if( !expected || [ 'title', 'description', 'widget_type' ].some( key => expected[key] !== current[key as keyof typeof current] && patch[key] !== current[key as keyof typeof current] ) ) throw new Error( 'Параметры изменились. Перечитайте их перед сохранением.' )
			return { ...patch }
		}
		@ $mol_action
		configure( definition: $shm_hitalama_map_widget_entity_custom, params: Record<string, any> ) {
			const patch = $mol_wire_sync( this ).configure_plan( definition, params )
			if( patch.title !== undefined ) definition.title( patch.title )
			if( patch.description !== undefined ) definition.Description( null )!.val( patch.description )
			if( patch.widget_type !== undefined ) definition.widget_type( patch.widget_type )
			return this.metadata( definition )
		}
		@ $mol_mem_key
		versions( name: string ) { return this.$.$shm_hitalama_components_versions.make({ definition: ()=> this.definition({ name }) }) }
		private scenario_service?: $shm_hitalama_components_scenario_service
		ui() { return this.ui_service ??= new this.$.$shm_hitalama_components_ui }
		scenarios() { return this.scenario_service ??= this.$.$shm_hitalama_components_scenario_service.make({ ui: ()=> this.ui() }) }
		destructor() { this.ui_service?.destructor(); this.scenario_service?.destructor(); super.destructor() }
		@ $mol_mem
		loader() { return new this.$.$shm_hitalama_map_component }
		@ $mol_action
		update( definition: $shm_hitalama_map_widget_entity_custom, params: Record< string, any > ) {
			const kind = this.kind( params.kind )
			if( typeof params.text !== 'string' || typeof params.expected !== 'string' ) throw new Error( 'Передайте text и expected из свежего чтения.' )
			const current = this.text( definition, kind )
			if( !definition.can_change() ) throw new Error( 'Нет прав на изменение модуля.' )
			if( current !== params.expected && current !== params.text ) throw new Error( 'Исходник изменился. Перечитайте модуль перед сохранением.' )
			if( current !== params.text ) {
				if( kind === 'dependencies' ) definition.Dependencies( null )!.val( params.text )
				else $mol_wire_sync( definition ).source_text( kind, params.text )
			}
			return { name: definition.class_name(), kind, saved: true }
		}
	}
}
